@if (page$ | async; as page) {
  @if (breadcrumbs$ | async; as breadcrumbs) {
    <div class="pt-2xl">
      <bgo-hero-cover-offering *transloco="let t" [content]="page.cover">
        @if (!breadcrumbs.showBackButton) {
          <cft-breadcrumbs [showBackButton]="false" [breadcrumbs]="breadcrumbs.breadcrumbs"></cft-breadcrumbs>
        }
        @if (breadcrumbs.showBackButton) {
          <cft-back-button [path]="linkService.previousPage ?? linkService.homePath"></cft-back-button>
        }
        <div content="pd-box">
          <bgo-start-job-progressive-disclosure-box
            [offering]="page"
            [intentions]="page.intentions"
            class="max-w-[380px] lg:max-w-full lg:min-w-[350px]"
          ></bgo-start-job-progressive-disclosure-box>
        </div>
        <cft-list-carousel [hasShadow]="false" class="w-full" navigationType="ghost">
          <div class="flex items-center justify-center" cftListCarouselSlide>
            <cft-google-rating [rating]="t('siteRating.rating')"></cft-google-rating>
          </div>
          <div class="flex items-center justify-center" cftListCarouselSlide>
            <div (click)="showHappinessDialog()" class="flex cursor-pointer items-center justify-center">
              <p class="max-w-[20em] text-center lg:max-w-fit">
                {{ t('offeringDirectory.sellingPoints.guaranteeText') }}
                <fa-icon class="pl-xs md:hidden" [icon]="infoIcon"></fa-icon>
              </p>
              <fa-icon class="hidden pl-xs md:inline-flex" [icon]="infoIcon"></fa-icon>
            </div>
          </div>
          <div class="flex flex-col items-center justify-center lg:flex-row" cftListCarouselSlide>
            <p>{{ t('offeringDirectory.sellingPoints.mobiText') }}</p>
            <bgo-mobiliar-logo class="lg:pt-2xs lg:pl-xs" />
          </div>
        </cft-list-carousel>
      </bgo-hero-cover-offering>
    </div>
    <div class="mt-2xl space-y-3xl md:mt-3xl md:space-y-20">
      @for (section of page.content; track $index; let last = $last) {
        @if (section.__type === 'ReviewSection') {
          <bgo-reviews-section
            [reviewSection]="section"
            (buttonClicked)="navigateToAboutUsPage()"
            class="h-layout"
            [class.pb-4xl]="last"
          ></bgo-reviews-section>
        }
        @if (section.__type === 'SupportSection') {
          <bgo-support-section [supportSection]="section" layout="h-layout" />
        }
        @if (section.__type === 'ProDirectory') {
          @let filterByRegion = region() | async;
          <bgo-pro-directory-by-offering-section
            [title]="page.title"
            [region]="filterByRegion || undefined"
            [offeringIds]="[page.id]"
          ></bgo-pro-directory-by-offering-section>
        }
        @if (section.__type === 'KnowledgeSection') {
          <bgo-knowledge-section class="h-layout" [knowledgeSection]="section"></bgo-knowledge-section>
        }
        @if (section.__type === 'PresentationSection') {
          <bgo-presentation-section [section]="section" layout="h-layout" />
        }
        @if (section.__type === 'SignupSection') {
          <bgo-lead-signup-section [section]="section"></bgo-lead-signup-section>
        }
        @if (section.__type === 'ContentSection' && section.content.json) {
          <div class="h-content-layout">
            <cft-content-section
              [title]="section.title"
              [plot]="section.plot"
              titleAlignment="left"
              [class.pb-4xl]="last"
            >
              <bgo-rich-text [content]="section.content"></bgo-rich-text>
            </cft-content-section>
          </div>
        }
        @if (section.__type === 'RelatedOfferingsSection' && page.relatedOfferings.length) {
          <bgo-related-items-section
            [title]="section.title | bgoReplaceProps: {offeringName: page.title}"
            [relatedItems]="page.relatedOfferings | mapRelatedOfferings"
          />
        }
        @if (section.__type === 'VideoSection') {
          <bgo-video-section class="h-content-layout" [section]="section" />
        }
      }
    </div>
  }
}
